import { Base } from "@studiometa/js-toolkit";
import { scrollTo } from "@studiometa/js-toolkit/utils";
class AnchorScrollTo extends Base {
  static config = {
    name: "AnchorScrollTo"
  };
  /**
   * Get the target selector.
   * @returns {string}
   */
  get targetSelector() {
    return this.$el.hash;
  }
  /**
   * Scroll to the target selector on click.
   * @param   {MouseEvent} event
   * @returns {void}
   */
  onClick(event) {
    try {
      scrollTo(this.targetSelector);
      event.preventDefault();
    } catch {
    }
  }
}
export {
  AnchorScrollTo
};
//# sourceMappingURL=AnchorScrollTo.js.map
